<template>
  <div class="tableList" v-loading="loading">
    <el-table
    class="fine-scroll-bar"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      :height="$store.state.userInfo.loginAsManagerId>0?'calc(100vh - 300px)':'calc(100vh - 265px)'"
      >
        <template slot="empty">
          <div class="emptycontent">
            <div class="emptycontentDiv">
              <div class="emptycontentimg">
                <img src="@/assets/image/common/mailnoData.png" alt="">
              </div>
              <div class="emptyText">
                暂无数据
              </div>
            </div>
          </div>
        </template>
        <!-- 序号 -->
      <el-table-column label="序号" type="index" :index="indexMethods" width="50"  align="center"></el-table-column>
      <!-- 营销任务 -->
      <el-table-column prop="name" :label="'营销任务'" min-width="300px">
        <template slot-scope="scope">
          <!-- v-if="scope.row.state!=10" -->
          <div @click="toDetail(scope)" class="divBtn fontsize14" >
            {{scope.row.name | noText}}
          </div>
          <!-- <div v-else>
            {{scope.row.name | noText}}
          </div> -->
          <div class="rowtitleDiv">
            <span class="rowtitle fontsize14">
              主题：
            </span>
             {{scope.row.title | noText}}
          </div>
           <div class="">
              <!-- <span class="rowtitleIconfont">
                <i class="iconfont icon-icon-renwuxinxi"></i>
              </span>
              <span class="rowcreatorName">
                {{scope.row.creatorName}}
              </span>  -->
              <span class="rowcreateTime">
                {{scope.row.createTime | format('YYYY-MM-DD HH:mm:ss')}}
              </span> 
          </div>
        </template>
      </el-table-column>
      <!-- 任务状态 -->
      <el-table-column prop="stateText" :label="'任务状态'" width="120px">
        <template slot-scope="scope">
          <div class="stateText">
            {{scope.row.stateText|noText}}
            <span v-if="scope.row.state==80">
              <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="top-end">
                <i class="iconfont icon-icon-xinxi"></i>
              </el-tooltip>
            </span>     
          </div>
        </template>
      </el-table-column>
      <!-- 发件总数 -->
      <el-table-column prop="sendTotal" :label="'发件总数'" width="120px">
          <template slot-scope="scope">
            <div v-if="[10,20,30,60,80].includes(scope.row.state)">---</div>
            <div v-else>
              {{scope.row.submitTotal || '---'}}
            </div>
          </template>
      </el-table-column>
      <!-- 效果分析 -->
      <el-table-column prop="alay" :label="'效果分析'" width="140px">
        <template slot-scope="scope">
          <div class="alay fontsize14" @click="alayOpen(scope)" v-if="[40,50].includes(scope.row.state)">
            <i class="iconfont icon-icon-chakancishu"></i> 查看人数：{{scope.row.viewMailUserNum}}
          </div>
          <div v-else>---</div>
        </template>
      </el-table-column>
      <!-- 发送时间 -->
      <el-table-column prop="scheduleSendTime" :label="'发送时间'" width="140px">
        <template slot-scope="scope">
          <div v-if="scope.row.state!=60">
            <span v-if="scope.row.realSendTime==null||scope.row.realSendTime==''">
              {{scope.row.scheduleSendTime | format('YYYY-MM-DD HH:mm')}}
            </span>
            <span v-else>
              {{scope.row.realSendTime | format('YYYY-MM-DD HH:mm')}}
            </span>
            <div class="timeIcon" v-if="scope.row.sendModel==2&&scope.row.state==20" >
              <i class="iconfont icon-icon-dingshi"></i>
            </div>
          </div>
          <div v-else>---</div>

        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column  :label="'操作'" width="60px" >
        <template slot-scope="scope">
          <div v-if="scope.row.state==10">
            <el-button v-no-more-click type="text" @click="editor(scope)">编辑</el-button>
          </div>
          <div>
            <el-button  v-no-more-click type="text" @click="copy(scope)">复制</el-button>
          </div>
          <div v-if="scope.row.state==20">
            <el-button v-no-more-click type="text" @click="cancel(scope)">撤销</el-button>
          </div>
          <div v-if="scope.row.state!=30">
            <el-button v-no-more-click type="text" @click="deletes(scope)">删除</el-button>
          </div>
          <div v-if="scope.row.state==30">
            <el-button v-no-more-click type="text" @click="stops(scope)">终止发送</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <!-- 效果分析 -->
      <div v-if="visible">
        <!-- :emdId="emdId" :sendModel="sendModel" :title="title" :scheduleSendTime="scheduleSendTime" :name="name" -->
        <analysis :visible="visible" @changeShow="$event=>{ visible = $event }"  :params="params"/>
      </div>
    </div>
  </div>
</template>
<script>
import analysis from "@/components/intellect-marketing/analysis/analysis"
import {imgRes} from "@/utils/config"
import {updateState,stopSend,copyById} from"@/utils/api/edmSubject"
export default {
  components:{
    analysis,
  },
  props:{
    tableData:{
      type:Array,
      default:[]
    },
    totalNum:{
      type:Number,
      default:0
    },
    curPage:{
      type:Number,
      default:1
    },
    pageSize:{
      type:Number,
      default:10
    }
  },
  data(){
    return{
      visible:false,
      imgRes:imgRes,
      params:{
        emdId:'',
        title:'',
        scheduleSendTime:'',
        sendModel:1,
        name:'',
        realSendTime:''
      },
      loading:false
    }
  },
  methods:{
  // 序号
    indexMethods(index){
      return index + (this.curPage - 1) * this.pageSize + 1;
    },
    // 查看效果分析
    alayOpen(scope){
      console.log('查看效果分析')
      this.visible=true
      this.params.emdId=scope.row.id
      this.params.title=scope.row.title
      this.params.scheduleSendTime=scope.row.scheduleSendTime
      this.params.sendModel=scope.row.sendModel
      this.params.name=scope.row.name
      this.params.realSendTime=scope.row.realSendTime
    },
    // 编辑
    editor(scope){
      if(scope.row.sendType==3){
        this.$router.push({
          name: 'customer-mail',
          query: {  
            id: scope.row.id,
            type: scope.row.state, }
        });
      }else{
        this.$router.push({
          name: 'created-mail',
          query: {  
            id: scope.row.id,
            type: scope.row.state, }
        });
      }
    },
    // 复制
    async copy(scope){
      console.log('copy')
      const params={
        id:scope.row.id
      }
      const res = await copyById(params)
      console.log(res)
      if(res.rspResult.bizCode==200){
        this.$message.success(res.rspResult.message)
        this.$emit('updateRefresh')
      }
    },
    // 撤销
    async cancel(scope){
      const params={
        "id": scope.row.id,
        "operaState": 2
      }
      const res=await updateState(params)
      if(res.rspResult.bizCode==200){
        this.$message.success(res.rspResult.message);
        this.$emit('updateRefresh')
      }
      
    },
    // 删除
   async deletes(scope){
      const params={
        "id": scope.row.id,
        "operaState": 1
      }
      const res=await updateState(params)
      if(res.rspResult.bizCode==200){
        this.$message.success(res.rspResult.message);
        this.$emit('updateRefresh')
      }
    },
    // 终止
    async stops(scope){
      const params={
        id:scope.row.id
      }
      const res=await stopSend(params)
      if(res.rspResult.bizCode==200){
        this.$message.success(res.rspResult.message);
        this.$emit('updateRefresh')
      }
    },
    // 邮件详情
    toDetail(scope){
      this.$router.push({
        name: 'mail-detail',
        query: { id:scope.row.id}
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .tableList{
    background: #FFFFFF;
    padding: 20px;
    margin-top: 4px;
  }
  .alay{
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066EB7;
    cursor: pointer;
    .iconfont{
      font-size: 12px;
    }
  }
  .emptycontent{
    min-height: 280px;
    .emptycontentDiv{
      // margin-top: calc(518 / 1200 * 100%);
      .emptycontentimg{
        width: 300px;
        height: 180px;
        // background: gray;
        margin: 0 auto;
        // margin-top: 200px;
        img{
          width: 100%;
          height: 100%;
        }
        // margin-bottom: 200px;
      }
      .emptyText{
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #4F5D78;
        line-height: 20px;
        // margin-bottom: 200px;
      }
    }

  }
.divBtn{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #066EB7;
  cursor: pointer;
}
.rowtitleDiv{
  word-break: break-word;
  font-size: 14px;
}
.rowtitle{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #16181A;

}
.rowcreatorName{
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 12px;
  color: #16181A;
  margin-right: 8px;
  margin-left: 5px;
}
.rowcreateTime{
  font-family: SourceHanSansCN-Medium;
  font-weight: 500;
  font-size: 12px;
  color: #16181A;
}
.timeIcon{
  text-align: center;
  .iconfont{
    font-size: 12px;
    color: #FF7F2A;
  }
}
.rowtitleIconfont{
  .iconfont{
    font-size: 12px;
    // color: #FF7F2A;
  }
}
.stateText{
  .iconfont{
    font-size: 12px;
  }
}
.fontsize14{
  font-size: 14px;
}
// 细滚动条类
::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}
</style>